import { useState } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import { FaUserCircle } from "react-icons/fa"
import { Link } from "react-router-dom";
import { BsChevronDown } from "react-icons/bs"
import { useDispatch, useSelector } from "react-redux";
import { setMember } from "../app/GlobalSlice";

const Navbar = () => {
  const dispatch = useDispatch()
  const { member } = useSelector(state => state.global);

  const [categoryBntHovered, setCategoryBtnHovered] = useState(false)
  const [profileBtnHovered, setProfileButtonHovered] = useState(false)

  console.log('member ', member)

  return (
    <div
      className="flex justify-center"
      style={{
        backgroundColor: '#232745',
        height: '60px'
      }}
    >

      <div
        className="h-full flex space-x-7"
        style={{
          width: '1200px'
        }}
      >
        <Link to={'/'}>
        <div
          className="flex items-center space-x-2 py-1"
        >
          
          <img src="/images/ahs-logo.png" width={'60px'}/>
        </div>
        </Link>
        <div
          className="flex-1 flex items-center space-x-5"
        >
          <div
            className="relative h-full cursor-pointer"
          >
            <div
              className="flex items-center space-x-2 text-white h-full font-bold"
              style={{
                fontSize: '13px'
              }}
              onMouseEnter={() => setCategoryBtnHovered(true)}
              onMouseLeave={() => setCategoryBtnHovered(false)}
            >
              <label className="cursor-pointer">Kategori</label>
              <BsChevronDown className="h-4 w-4"/>
            </div>
            {categoryBntHovered && (
              <div
                className="absolute top-14 py-3 px-3 bg-white rounded-tl-lg rounded-bl-lg text-gray-700 overflow-y-auto"
                style={{
                  width: '300px',
                  maxHeight: '350px',
                  fontSize: '14px'
                }}
                onMouseEnter={() => setCategoryBtnHovered(true)}
                onMouseLeave={() => setCategoryBtnHovered(false)}
              >
                <div>
                  <Link to={'/courses/CCT0001'}>
                    <button 
                      className="w-full text-left py-2 px-5 rounded-full hover:bg-green-200 hover:text-green-700 font-bold "
                    >
                      Public Training
                    </button>
                  </Link>
                </div>
                <div>
                  <Link to={'/settings/profile'}>
                    <button 
                      className="w-full text-left py-2 px-5 rounded-full hover:bg-green-200 hover:text-green-700 font-bold "
                    >
                      Company Certification
                    </button>
                  </Link>
                </div>
                <div>
                  <Link to={'/settings/profile'}>
                    <button 
                      className="w-full text-left py-2 px-5 rounded-full hover:bg-green-200 hover:text-green-700 font-bold "
                    >
                      Academy Certification
                    </button>
                  </Link>
                </div>
              </div>
            )}
          </div>
          <div className="flex-1 relative">
            <input 
              className="h-full w-full py-2 px-2 rounded-md outline-green-500"
              placeholder="Ingin belajar apa hari ini?"
              style={{
                fontSize: '14px'
              }}
            />
            <div class="flex absolute inset-y-0 right-3 items-center pl-3">
              <AiOutlineSearch className="w-5 h-5"/>
            </div>
          </div>
        </div>
        {
          member.id === null ?
            (<div
              className="flex items-center"
            >
              <Link to={'/login'}>
              <button
                className="px-3 py-2 text-white rounded-lg uppercase font-bold"
                style={{
                  fontSize: '13px',
                  backgroundColor: 'rgb(44 179 172)'
                }}
              >
                Daftar/Masuk
              </button>
              </Link>
            </div>)
            :
            (<div
              className="flex items-center space-x-5"
            >
              <div
                className="text-white flex items-center h-full font-bold"
                style={{
                  fontSize: '13px'
                }}
              >
                <Link to="/">
                  <label>Kelas saya</label>
                </Link>
              </div>
              <div 
                className="flex items-center h-full relative p-2"
                onMouseEnter={() => setProfileButtonHovered(true)}
                onMouseLeave={() => setProfileButtonHovered(false)}
              >
                <div
                  className="cursor-pointer"
                >
                  <FaUserCircle className="h-7 w-7 text-white"/>
                </div>
                {profileBtnHovered && (
                  <div
                    className="absolute top-14 py-3 bg-white rounded-sm text-gray-700 space-y-1"
                    style={{
                      width: '190px',
                      marginLeft: '-160px',
                      fontSize: '14px'
                    }}
                    onMouseEnter={() => setProfileButtonHovered(true)}
                    onMouseLeave={() => setProfileButtonHovered(false)}
                  >
                    <div>
                      <Link to={'/settings/profile'}>
                        <button className="w-full text-left py-2 px-3 hover:bg-gray-200">Edit Profil</button>
                      </Link>
                    </div>
                    <div>
                      <Link to={'/settings/password'}>
                        <button className="w-full text-left py-2 px-3 hover:bg-gray-200">Ubah Password</button>
                      </Link>
                    </div>
                    <div>
                      <button 
                        className="w-full text-left text-red-600 py-2 px-3"
                        onClick={() => {
                          dispatch(setMember({
                            id: null
                          }))
                        }}
                      >
                        Logout
                      </button>
                    </div>
                  </div>
                )}
              </div>
              
            </div>)
        }
        

      </div>

    </div>
  )

}

export default Navbar;